const dataTitleOfBoxFoodOwnRestaurant = [
  {
    id: 0,
    title: "Ưu đãi hôm nay",
    state: true,
  },
  {
    id: 1,
    title: "Combo Cùng Pepsi, Bao Rẻ Bao Đã",
    state: true,
  },
  {
    id: 2,
    title: "Combo 1 người",
    state: true,
  },
  {
    id: 3,
    title: "Món cơm",
    state: true,
  },
  {
    id: 4,
    title: "Đã Quá Pepsi Ơi",
    state: true,
  },
  {
    id: 5,
    title: "Món Thêm",
    state: true,
  },
  {
    id: 6,
    title: "Đồ uống",
    state: true,
  },
  {
    id: 7,
    title: "Hàng tặng không bán (vui lòng không chọn)",
    state: true,
  },
  {
    id: 8,
    title: "Món canh",
    state: true,
  },
];
export default dataTitleOfBoxFoodOwnRestaurant;
